import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ts1 from '../../images/testimonial/t1.png'
import ts2 from '../../images/testimonial/t3.png'
import ts3 from '../../images/testimonial/t2.png'
import ts4 from '../../images/testimonial/t4.png'
import SectionTitle from "../SectionTitle";


const settings = {
    dots: false,
    arrows: false,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
        {
            breakpoint: 1500,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
};

const testimonial = [
    {
        tsImg: ts1,
        Des: "Excellent product quality and timely delivery. Jagruti Chemicals has become our trusted supplier for all industrial needs.",
        Title: 'Rajesh Kumar',
    },
    {
        tsImg: ts2,
        Des: "Very professional team and outstanding customer support. Their products are reliable and meet all our quality expectations.",
        Title: 'Priya Mehta',
    },
    {
        tsImg: ts3,
        Des: "We've been purchasing from Jagruti Chemicals for a while, and their consistency and service have always impressed us.",
        Title: 'Arvind Sharma',
    },
    {
        tsImg: ts4,
        Des: "High-quality chemicals and great communication throughout the process. Truly a dependable company to work with.",
        Title: 'Neha Pillai',
    },
]

const Testimonial = () => {
    return (
        <section className="wpo-testimonials-section section-padding" style={{ paddingTop: '0px' }}>
            <div className="container">
                <div className="row align-items-center justify-content-center">
                    <div className="col-lg-6">
                        <SectionTitle 
                            MainTitle={'Testimonial'} 
                            description={'Jagruti Chemicals delivers top-quality products with consistent reliability. Always satisfied with their service.'} 
                        />
                    </div>
                </div>
                <div className="row align-items-center">
                    <div className="col-xl-12 col-lg-12">
                        <div className="testimonials-wrapper owl-carousel">
                            <Slider {...settings}>
                                {testimonial.map((tesmnl, tsm) => (
                                    <div className="testimonials-item" key={tsm}>
                                        <div className="testimonials-item-top">
                                            <p>{tesmnl.Des}</p>
                                        </div>
                                        <div className="testimonials-item-bottom">
                                            <div className="testimonials-item-bottom-author">
                                                <img src={tesmnl.tsImg} alt="" />
                                            </div>
                                            <div className="testimonials-item-bottom-author-text">
                                                <h3>{tesmnl.Title}</h3>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Testimonial;